import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from "react-icons/fa6";  // Import the spinner

export default function PubDetails() {
    const phoneNo = useSelector((state) => state.pubLogin.userPhone);
    const [user, setUser] = useState({
        name: "",
        phone: phoneNo, // User's phone number is populated from the state
        address: "",
        pin: "",
        age: ""
    });
    const [loading, setLoading] = useState(false);  // Loading state

    useEffect(() => {
        const fetchUserDetails = async () => {
            setLoading(true);  // Start loading
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/getUserDetails`, {
                    params: { phone: phoneNo }
                });
                const userData = response.data;
                setUser({
                    name: userData.Name,
                    phone: userData.Phone,
                    address: userData.Address,
                    pin: userData.Pin,
                    age: userData.Age
                });
            } catch (error) {
                console.error("Error fetching user details:", error);
                toast.error("Failed to fetch user details. Please try again later.");
            } finally {
                setLoading(false);  // Stop loading once request is complete
            }
        };

        fetchUserDetails();
    }, [phoneNo]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser((prevUser) => ({
            ...prevUser,
            [name]: value
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);  // Start loading when submitting
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/updateUserDetails`, user);
            toast.success(response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (error) {
            console.error("Error updating user details:", error);
            toast.error("Error updating profile. Please try again.");
        } finally {
            setLoading(false);  // Stop loading once request is complete
        }
    };

    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">My Profile</h1>
            <div className="card shadow-lg p-4" style={cardStyle}>
                {loading ? (  // Show the spinner when loading
                    <div className="text-center">
                        <FaSpinner className="spinner-border" style={{ fontSize: "36px", animation: "spin 2s linear infinite" }} />
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label htmlFor="nameInput" style={labelStyle}>Name</label>
                            <input
                                type="text"
                                name="name"
                                id="nameInput"
                                className="form-control"
                                style={inputStyle}
                                placeholder="Enter your name"
                                value={user.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label htmlFor="whnumInput" style={labelStyle}>WhatsApp Number</label>
                            <input
                                type="tel"
                                name="phone"
                                id="whnumInput"
                                className="form-control"
                                style={inputStyle}
                                placeholder="+91XXXXXXXXXX"
                                value={user.phone}
                                readOnly // Make the phone number read-only
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label htmlFor="addressInput" style={labelStyle}>Delivery Address</label>
                            <textarea
                                name="address"
                                rows="3"
                                id="addressInput"
                                className="form-control"
                                style={inputStyle}
                                placeholder="Enter your street address"
                                value={user.address}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label htmlFor="pincodeInput" style={labelStyle}>Pincode</label>
                            <input
                                type="text"
                                pattern="[0-9]{6}"
                                title="Please enter a valid 6-digit pincode."
                                name="pin"
                                id="pincodeInput"
                                className="form-control"
                                style={inputStyle}
                                placeholder="XXXXXX"
                                value={user.pin}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label htmlFor="ageInput" style={labelStyle}>Age</label>
                            <input
                                type="number"
                                name="age"
                                id="ageInput"
                                className="form-control"
                                style={inputStyle}
                                placeholder="Enter your age"
                                value={user.age}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="text-center">
                            <button type="submit" className="btn btn-success btn-lg rounded-pill shadow">
                                Update Details
                            </button>
                        </div>
                    </form>
                )}
            </div>
            <ToastContainer />
        </div>
    );
}

const cardStyle = {
    background: "rgba(255, 255, 255, 0.2)", // Blurred background
    backdropFilter: "blur(15px)", // Apply blur effect
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
};

const labelStyle = {
    fontWeight: "bold", // Make labels bold
    color: "#000", // Ensure labels are clearly visible
};

const inputStyle = {
    fontWeight: "bold", // Make input text bold
    background: "rgba(255, 255, 255, 0.9)", // Solid background for inputs
    borderColor: "#000", // Darker border for inputs
};
